module.exports = __webpack_public_path__ + "static/img/11.41bfbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/11.png
// module id = 9MqN
// module chunks = 3